import React from "react";
import { useNavigate } from "react-router-dom";
import globalreachbg from "../images/globalreach/globalreach.png";
import globalreachmobile from "../images/globalreach/globalreachmobile.jpg";

const flags = [
  { code: "us", img: "https://flagcdn.com/w40/us.png" },
  { code: "gb", img: "https://flagcdn.com/w40/gb.png" },
  { code: "ca", img: "https://flagcdn.com/w40/ca.png" },
  { code: "ae", img: "https://flagcdn.com/w40/ae.png" },
  { code: "sa", img: "https://flagcdn.com/w40/sa.png" },
  { code: "sg", img: "https://flagcdn.com/w40/sg.png" },
  { code: "au", img: "https://flagcdn.com/w40/au.png" },
  { code: "in", img: "https://flagcdn.com/w40/in.png" },
];

const HomeglobalReach = () => {
  const navigate = useNavigate();

  return (
    <>
      <section className="global-sectiong">
        {/* Overlay */}
        <div className="global-overlayg"></div>

        <div className="global-containerg">
          {/* leftg CONTENT */}
          <div className="leftg">
            <p className="tagg">Global Reach</p>

            <h1>
              Exporting Goodness <br /> Across the Globe
            </h1>

            <p className="descg">
              Our products are trusted in 30+ countries around the world,
              delivering freshness and quality globally.
            </p>

            <div className="flags">
              {flags.map((flag, i) => (
                <img key={i} src={flag.img} alt={flag.code} />
              ))}
            </div>

            {/* BUTTON */}
            <button className="cta" onClick={() => navigate("/products")}>
              🛒 Explore Our Products →
            </button>
          </div>
        </div>
      </section>

      {/* CSS */}
      <style>{`
        .global-sectiong {
        position: relative;
        min-height: 420px;
        display: flex;
        align-items: center;
        padding: 60px 8%;
        background: url(${globalreachbg}) center/cover no-repeat;
        overflow: hidden;
        }

        /* ✅ MOBILE IMAGE SWITCH */
        @media (max-width: 768px) {
        .global-sectiong {
            background: url(${globalreachmobile}) center/cover no-repeat;
            padding: 40px 20px;
        }
        }

        /* DARK PREMIUM OVERLAY */
        .global-overlayg {
          position: absolute;
          inset: 0;
          background: linear-gradient(120deg, rgba(56, 59, 58, 0.68), rgba(223, 223, 223, 0));
        }

        .global-containerg {
          position: relative;
          z-index: 2;
          max-width: 1200px;
          color: white;
        }

        /* tagg */
        .tagg {
          color: #f2d74f;
          font-size: 14px;
          font-weight: 800;
          text-shadow: 0 4px 3px rgba(0, 0, 0, 0.4);
        //   margin-bottom: 10px;
          letter-spacing: 1px;
        }

        /* HEADING */
        .leftg h1 {
          font-size: clamp(28px, 4vw, 42px);
          font-weight: 800;
          line-height: 1.2;
          margin-bottom: 15px;

          background: linear-gradient(90deg, #fff, #fbfcfc, #f5f8f6);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
        }

        /* descg */
        .descg {
          max-width: 420px;
          color: #f5f6f8;
          margin-bottom: 25px;
          text-shadow: 0 4px 3px rgba(0, 0, 0, 0.4);
          font-size: 15px;
        }

        /* FLAGS */
        .flags {
          display: flex;
          gap: 12px;
          margin-bottom: 25px;
          flex-wrap: wrap;

          max-width: 500px;   /* 🔥 increase width */
          min-height: 120px;  /* 🔥 increase height */
        }

        .flags img {
          width: 53px;
          height: 40px;
          border-radius: 5px;
          background: rgba(255,255,255,0.2);
          padding: 3px;
          transition: 0.3s;
        }

        .flags img:hover {
          transform: translateY(-4px);
        }
        .flags span:hover {
          transform: translateY(-4px);
          background: rgba(255,255,255,0.2);
        }

        /* BUTTON */
        .cta {
          background: linear-gradient(90deg, #22c55e, #4ade80);
          border: none;
          padding: 12px 24px;
          border-radius: 30px;
          color: #ffffff;
          text-shadow: 0 2px 3px rgba(0, 0, 0, 0.4);
          font-weight: 600;
          cursor: pointer;
          transition: 0.3s;
        }

        .cta:hover {
          transform: translateY(-2px);
          box-shadow: 0 10px 25px rgba(34,197,94,0.4);
        }

        /* MOBILE */
        @media (max-width: 768px) {
          .global-sectiong {
            padding: 40px 20px;
          }

          h1 {
            font-size: 26px;
          }

          .descg {
            font-size: 14px;
          }
        }
      `}</style>
    </>
  );
};

export default HomeglobalReach;
